import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { URLTriggerModal } from '../components/urlTriggerModal';
const translatePayload = (node) => {
    const { defaultNextNodeId, routes } = node.payload;
    const urlTriggerConnections = routes.map(({ nextNodeId, urlPrefix }) => ({
        id: nextNodeId,
        label: urlPrefix,
        connection: nextNodeId,
    }));
    return [
        {
            id: uuid(),
            label: 'Default',
            connection: defaultNextNodeId || uuid(),
        },
        ...urlTriggerConnections,
    ];
};
const updateConnection = (node, connection, connectionId) => {
    const { payload } = node;
    const { routes } = payload;
    const newNode = Object.assign(Object.assign({}, node), { payload: Object.assign({}, payload) });
    if (connection.connectionLabel === 'Default') {
        newNode.payload.defaultNextNodeId = connectionId;
    }
    else if (connection.connectionLabel && connection.connectionLabel) {
        const routeIndex = routes.findIndex((route) => route.urlPrefix === connection.connectionLabel);
        if (routeIndex !== -1) {
            newNode.payload.routes = [...routes];
            newNode.payload.routes[routeIndex] = Object.assign(Object.assign({}, routes[routeIndex]), { nextNodeId: connectionId });
        }
    }
    return newNode;
};
export const URLTriggerNodeAttributes = {
    iconName: 'url-trigger',
    label: 'URL Trigger',
    color: hexStringToNumber(flowNodeColor.purple),
    translatePayload,
    updateConnection,
    NodeContent: URLTriggerNode,
    ActionModal: URLTriggerModal,
};
export function URLTriggerNode({ node }) {
    const { payload } = node;
    const { routes } = payload;
    const urlCount = routes.length;
    const urlText = urlCount === 1 ? 'URL' : 'URLs';
    return (_jsx(TextContent, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: `${urlCount} ${urlText}` }) })), [urlCount, urlText]) }));
}
